module.exports = __webpack_public_path__ + "prod/1.42.2/media/esignIndex-newbattle.14067151.mp4";